import React, { Component } from "react";
import {  Loader, Icon, Message, Tab, Header, Form, Table, Select, Input, Dropdown, List, Button, Modal, Divider, Checkbox} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, uploadS3Text } from "../libs/awsLib";
import config from "../config";

import JSONDataEntry from "./JSONDataEntry";
import { exporttoJSON } from "../libs/sharedFunctions";
import _ from 'lodash';


export default class DeviceConfigurations extends Component {
  constructor(props) {
    super(props);


    this.state={deviceConfigurations: {}, tabIndex: 0, uploadSuccess: false, uploadFailed: false, showAddNewModal: false, newConfigurationName: null, configToCopy: 'blank',  filepath: null, loading: true};

  }


  
  componentDidMount ()
  {
    this.loadContent();
  }

  addDeviceConfiguration(name)
  {
    var copyData=_.cloneDeep(this.state.deviceConfigurations);
    copyData[name]=this.props.newConfigurationTemplate;
    this.setState({deviceConfigurations: copyData})
  }

  updateDeviceConfiguration(name, data)
  {
    var copyData= _.cloneDeep(this.state.deviceConfigurations);
    copyData[name]=_.cloneDeep(data);
    this.setState({deviceConfigurations: copyData})
  }


  deleteDeviceConfiguration(deviceConfiguration)
  {
    var copyData=_.cloneDeep(this.state.deviceConfigurations);
    delete copyData[deviceConfiguration]
    this.setState({deviceConfigurations: copyData})
  }

  loadContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/deviceconfigurationrules.json'
    downloadS3Text(bucket, key).then(result=>{console.log(result); this.setState({deviceConfigurations: result, loading: false})})
  }
  saveContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/deviceconfigurationrules.json'
    //update json 
    uploadS3Text(bucket, key, this.state.deviceConfigurations).then(result=>{this.setState({uploadSuccess: true, uploadFailed: false, validationErrors: []})}).catch(result=>{this.setState({uploadSuccess: false, uploadFailed: true, validationErrors: ['Failed to save device configurations file']})})
  }

  closeAddNewModal=()=>
  {
    this.setState({showAddNewModal: false, configToCopy: null, newConfigurationName: null})
  }
 

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  addNewDeviceConfiguration()
  {
    //check the name is different
    if (this.state.newConfigurationName !== null && this.state.newConfigurationName !== "")
        {
          if (this.state.newConfigurationName in this.state.deviceConfigurations)
            alert("Device configuration name already exists")
        else {
          // if select (dropdown) is not blank/create blank
          if (this.state.configToCopy === null)
          alert("Create a new configuration or select an existing configuration to use as a template")
          else {
            if (this.state.configToCopy === 'blank'){
                this.addDeviceConfiguration(this.props.devicetype+"_"+this.state.newConfigurationName);
                this.setState({showAddNewModal: false});
                this.closeAddNewModal();
              }
            else
            {
              // copy data from the selected policy
              var copyData=_.cloneDeep(this.state.deviceConfigurations);
              var copyConfig=this.state.deviceConfigurations[this.state.configToCopy];
              copyData[this.props.devicetype+"_"+this.state.newConfigurationName]=_.cloneDeep(copyConfig);
              this.setState({deviceConfigurations: copyData})
              this.closeAddNewModal();
            }
          }
        }
         }
    else alert("Please provide a device configuration name")

  }


 render() {
  const handleTabChange=(e, data)=>
  {

    //handle add new click
    if (data.activeIndex===Object.keys(this.state.deviceConfigurations).filter(key=>{return key.startsWith(this.props.devicetype)}).length)
    {
      this.setState({showAddNewModal: true})
    }
    this.setState({tabIndex: data.activeIndex})
  }

        var deviceConfigurations=[{key: 0, text: 'New Device Configuration', value: 'blank'}]
        Object.keys(this.state.deviceConfigurations).filter(key=>{return key.startsWith(this.props.devicetype)}).forEach((deviceConfiguration, i)=>deviceConfigurations.push({key: i+1, text: deviceConfiguration, value: deviceConfiguration}))
     
        const panes = Object.keys(this.state.deviceConfigurations).filter(key=>{return key.startsWith(this.props.devicetype)}).map(deviceConfigurationname=>{
          var deviceConfiguration=this.state.deviceConfigurations[deviceConfigurationname];
          return { menuItem: {key: deviceConfigurationname, content: deviceConfigurationname.slice(this.props.devicetype.length+1), icon: 'wrench'}, render: () => <Tab.Pane>
        <div>
        <JSONDataEntry jsonformat={this.props.jsonFormat} data={deviceConfiguration} editmode={true} onDataChange={newData=>{this.updateDeviceConfiguration(deviceConfigurationname, newData)}} darkmode={this.props.darkmode}/>
        </div>
        </Tab.Pane> }
        });
      panes.push({ menuItem: {key: "Add", content: "Add New", icon: 'add'}, render: ()=><Tab.Pane></Tab.Pane>})
      if (this.state.loading)
        return <Loader/>
      else       return (
      <div className="fullpagetab">
      <div>
      <Tab  grid= {{paneWidth: 13, tabWidth: 3}} menu={{tabular: false, fluid: true, vertical: true, className: this.props.darkmode ? "seaglassblueinverted-darkmode viewtabmenu" : "seaglassblueinverted viewtabmenu", inverted: true }} activeIndex={this.state.tabIndex} panes={panes} onTabChange={handleTabChange} />
      </div>
      {this.state.uploadFailed && <Message error header="Failed to save device configurations" list={this.state.validationErrors}/>}
      {this.state.uploadSuccess && <Message success header="Device configurations successfully saved"/>}
      <Modal open={this.state.showAddNewModal}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add" onClick={this.addNewPolicy}/>Add New Device Configuration</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Input
          id="newConfigurationName"
          label="Device Configuration Name"
          fluid
          required
          placeholder='Device Configuration Name'
          value={this.state.newConfigurationName}
          onChange={this.handleChange}
        />
        <Form.Select label="Device Configuration to Copy" placeholder="Device Configuration to Copy" required options={deviceConfigurations} onChange={(event, data)=>{this.setState({configToCopy: data.value})}}></Form.Select>
        <Divider/>
        {this.state.components && <Button className="seaglassbutton" disabled={!this.state.formValid || this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>}
        <Button className='seaglassbutton' onClick={()=>this.addNewDeviceConfiguration()}>Add</Button>
        <Button className="seaglassbutton" onClick={this.closeAddNewModal}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>   
      <div>
      <Divider/>
      <Button className='seaglassbutton' onClick={()=>this.saveContent()}>Save</Button>
      <Button className='seaglassbutton' onClick={()=>this.loadContent()}>Reset</Button>
      </div>
      </div>

    
    );  

  
    }
  }